export const GOOGLE_LOGIN_CLIENT_ID =
    process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID ?? ''

export const ACCEPTED_MEDIA_FORMATS = [
    'image/jpeg',
    'image/png',
    'image/tiff',
    'image/webp',
    'video/mp4',
    'video/mov',
    'video/avi',
    'video/mpeg4',
    'audio/mpeg',
    'audio/wav',
    'audio/ogg',
    'video/quicktime',
    'video/x-matroska',
    'video/webm',
]
